/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Relationship } from './relationship';


/**
 * Payload for patching a relationship
 */
export interface RelationshipPatch { 
    action?: RelationshipPatch.ActionEnum;
    relation_tuple?: Relationship;
}
export namespace RelationshipPatch {
    export type ActionEnum = 'insert' | 'delete';
    export const ActionEnum = {
        Insert: 'insert' as ActionEnum,
        Delete: 'delete' as ActionEnum
    };
}


